import { Component, OnInit, Input } from '@angular/core';

import { DistanceUnits, EmrButtonComponent, TraxxInfo } from 'emr-ng-shared';
import { ShipmentService } from 'app-modules/core/services/shipment.service';
import { buttonHideBreadcrumb, buttonShowBreadcrumb, buttonRepairCrumb, buttonUnRepairCrumb, dist_km, dist_miles, dist_feet, dist_meters } from 'app-modules/core/consts/localization';
import { AuthService } from 'app-modules/core/store/auth/auth.service';
import { Subscription } from 'rxjs';
import { NgFor, NgIf } from '@angular/common';
import { LocalLoadingIndicatorComponent } from 'app-modules/core/components/local-loading-indicator/local-loading-indicator.component';

@Component({
  selector: 'app-breadcrumb-info-box-content',
  templateUrl: './breadcrumb-info-box-content.component.html',
  styleUrls: ['./breadcrumb-info-box-content.component.css'],
  standalone: true,
  imports: [NgIf, EmrButtonComponent, NgFor, LocalLoadingIndicatorComponent]
})
export class BreadcrumbInfoBoxContentComponent implements OnInit {

  @Input() markerInfo: TraxxInfo;
  @Input() isFromSensorChart: boolean = false;
  @Input() isFromTimeline: boolean = false;
  public distanceUnits: DistanceUnits;
  public isShowingLocationOrGeoFence: boolean = false;
  public isAdmin: boolean = false;
  public isZoomInfoLevel: boolean = true;
  public showInfoZoomOption: boolean = true;
  buttonHideBreadcrumbText: string;
  buttonShowBreadcrumbText: string;
  public selectedRadiusBreadCrumbId: number;
  public isUserLocusAdminSupport: boolean = false;
  authStateSub: Subscription;
  public displayUnits: string;
  @Input() is4G: boolean = false;
  @Input()
  set isZoomedInfoLevel(value) {
    this.isZoomInfoLevel = value;
  }

  @Input()
  set setShowingLocationOrGeoFence(value) {
    this.isShowingLocationOrGeoFence = value;
  }

  @Input()
  set setDistanceUnits(value) {
    this.distanceUnits = value;
  }

  @Input()
  set checkAdminRole(value) {
    this.isAdmin = value;
  }

  @Input()
  set selectedBreadCrumbRadius(value) {
    this.selectedRadiusBreadCrumbId = value;
  }

  @Input()
  set showInfoBoxZoom(value) {
    this.showInfoZoomOption = value;
  }
  @Input() showHiddenCrumbs = false;

  isAuthenticated = false;
  canEditTripName: boolean = false;
  isLocusAdmin: boolean = false;

  constructor(
    private shpSvc: ShipmentService,
    private authSvc: AuthService
  ) { }

  ngOnInit() {
    this.authStateSub = this.authSvc.authState$.pipe().subscribe(n => {
      this.isUserLocusAdminSupport = (n?.isLocusSupport || n?.isEmersonAdmin);
      this.isLocusAdmin = n ? n.isEmersonAdmin : false;
      this.canEditTripName = n ? n.canEditTripName : false;
      this.authStateSub?.unsubscribe();
    });
    this.isAuthenticated = !this.shpSvc.getUnAuthenticationToken();
    this.buttonHideBreadcrumbText = buttonRepairCrumb;
    this.buttonShowBreadcrumbText = buttonUnRepairCrumb;
  }

  getDataByUnits(value): string {
    let accuracyRadius = this.distanceUnits === DistanceUnits.Kilometers ? value / 1000 : (value * 0.00062137);
    let units = "";
    let calculatedValue = "";
    if (this.distanceUnits === DistanceUnits.Kilometers) {
      units = accuracyRadius >= 0.1 ? dist_km : dist_meters;
      calculatedValue = accuracyRadius >= 0.1 ? (this.getRoundOfValue(accuracyRadius)) : this.getRoundOfValue(value, true);
    } else {
      units = accuracyRadius >= 0.1 ? dist_miles : dist_feet;
      calculatedValue = accuracyRadius >= 0.1 ? this.getRoundOfValue(accuracyRadius) : this.getRoundOfValue(value / 0.3048, true);
    }
    return calculatedValue + ' ' + units;
  }

  getRoundOfValue(value, isNonDecimal: boolean = false): string {
    let returnValue;
    if (value == Math.floor(value) || isNonDecimal) {
      returnValue = value.toFixed();
    } else {
      returnValue = value.toFixed(1);
    }
    return Number(returnValue).toString();
  }
}

